import { createAction } from 'redux-starter-kit';
import { get, post } from '../../../utility/via-fetch';
import { requestStart, requestSucceded, requestFailed } from '../../domain/requests/RequestActions';
import { putBuckets, putBucket } from '../../domain/buckets/bucketActions';
import { addMessage } from '../application/messageUiActions';

/**
 * An action that signifies a bucket is being currently edited.
 */
export const editBucket = createAction('EDIT_BUCKET');

/**
 * An action that signifies a bucket is no longer being edited.
 */
export const cancelEditBucket = createAction('CANCEL_EDIT_BUCKET');

/**
 * An action that signifies a request to retrieve all buckets for a management company
 */
export const fetchAllBuckets = createAction('FETCH_ALL_BUCKETS');

/**
 * An action that retrieves all buckets for a management company
 */
export function requestAllBuckets(manageCompany) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchAllBuckets().toString()));
    dispatch(fetchAllBuckets(requestId));
    try {
      const buckets = await get('/api/tokens/buckets/company/' + manageCompany, undefined, {});

      dispatch(putBuckets(buckets));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}

/**
 * An Action marking a request to save a new bucket
 */
export const saveBucket = createAction('SAVE_BUCKET');

/**
 * An action that saves a new bucket to the database
 */
export function requestCreateBucket(newBucket, manageCompany) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchAllBuckets().toString()));
    dispatch(fetchAllBuckets(requestId));
    try {
      const bucketId = await post('/api/tokens/buckets/company/' + manageCompany, undefined, newBucket);
      dispatch(putBucket({ ...newBucket, id: bucketId }));
      dispatch(addMessage('success', 'itemSaved', { item: newBucket.description }));
      dispatch(cancelEditBucket());
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

/**
 * An Action marking a request to amend a bucket
 */
export const updateBucket = createAction('UPDATE_BUCKET');

/**
 * An action that saves a new bucket to the database
 */
export function requestUpdateBucket(newBucket) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(updateBucket().toString()));
    dispatch(updateBucket(requestId));
    try {
      //TODO implement if needed
      //await post(`/api/tokens/buckets/${newBucket.id}`, undefined, newBucket);
      dispatch(putBucket({ ...newBucket }));
      dispatch(addMessage('success', 'itemUpdated', { item: newBucket.title }));
      dispatch(cancelEditBucket());
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}
